"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const defaultCache_1 = (0, tslib_1.__importDefault)(require("./defaultCache"));
const createLink_1 = (0, tslib_1.__importDefault)(require("./createLink"));
const options_1 = require("../options");
const refreshJWT_1 = (0, tslib_1.__importDefault)(require("./refreshJWT"));
const isSsrMode_1 = (0, tslib_1.__importDefault)(require("./isSsrMode"));
const defaultOptions = {
    endpointURL: 'http://localhost:3000',
    subscriptionsPath: '/subscriptions',
    useSubscriptions: true,
    saveSession: () => {
        throw new Error('You must pass a function to save the session');
    },
    getSession: () => {
        throw new Error('You must pass a function to get the saved session');
    },
    cache: defaultCache_1.default,
    batchInterval: 20,
    batch: true,
    canRetry: true,
    promptTwoFactorCode: () => prompt('Please write your two factor code to continue'),
    onError: () => { },
    getHeaders: () => { },
    resolvers: null,
    wsOptions: {},
    getJWT: () => { },
    upgradeJWT: () => { },
    refreshJWT: null,
    apolloOverrides: {}
};
function createClient(passedOptions) {
    const options = { ...defaultOptions, ...passedOptions };
    (0, options_1.setOptions)(options);
    const link = (0, createLink_1.default)(options);
    if (options.refreshJWT) {
        if (options.upgradeJWT) {
            setTimeout(() => {
                const oldSession = options.getSession() || {};
                if (!options.getJWT() && oldSession.userId) {
                    console.log('Performing initial JWT upgrade...');
                    (0, refreshJWT_1.default)(options);
                }
            }, 1000);
        }
        setInterval(() => (0, refreshJWT_1.default)(options), 5 * 60 * 1000);
    }
    const client = new client_1.ApolloClient({
        ssrMode: (0, isSsrMode_1.default)(options),
        link,
        cache: options.cache,
        resolvers: options.resolvers,
        ...options.apolloOverrides
    });
    options.apolloClient = client;
    client._orionOptions = options;
    client._wsClient = options.wsClient;
    (0, options_1.setOptions)(options);
    return client;
}
exports.default = createClient;
